import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as rccActions from "../../../actions/rccActions";
import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as rcc from "../../../constants/rcc";
import * as modelHelper from "../../../helpers/modelHelper";

import imgErrors from "../../../resources/img/svgicons/reset-errors.svg";

import Modal from "../generic/Modal";
import Table from "../generic/Table";
import CloseButton from "../generic/CloseButton";
import Button from "../generic/Button";

class MachineErrorsModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseMachineErrorsModalAction();
    };

    handleResetErrorsClick = () => {
        this.props.dispatchResetErrors();
    };

    getTableRows = () => {
        const result = [];

        this.props.machineErrors.forEach((error, i) => {
            result.push(
                modelHelper.buildTableRow(
                    [
                        modelHelper.buildTableCell(error.code),
                        modelHelper.buildTableCell(error.typeName),
                        modelHelper.buildTableCell(error.description),
                        modelHelper.buildTableCell(error.canister ?? ""),
                        modelHelper.buildTableCell(error.channel ?? "")
                    ],
                    "",
                    i
                )
            );

            if (error.subErrors) {
                result.push(
                    ...error.subErrors.map((subError, j) => {
                        return modelHelper.buildTableRow(
                            [
                                modelHelper.buildTableCell(subError.code),
                                modelHelper.buildTableCell(subError.typeName),
                                modelHelper.buildTableCell(subError.description),
                                modelHelper.buildTableCell(subError.canister ?? ""),
                                modelHelper.buildTableCell(subError.channel ?? "")
                            ],
                            "",
                            i + "-" + j
                        );
                    })
                );
            }
        });

        return result;
    };

    getResetButton = () => {
        const disabled =
            this.props.isBusy &&
            this.props.dialog !== null &&
            this.props.dialog.message !== rcc.RCC_MESSAGE_RESET_ERRORS;

        return (
            <Button
                tooltipText={disabled ? translate("help.machineIsBusy") : null}
                svgBefore={imgErrors}
                label={<Translate value="machineErrors.resetErrors" />}
                disabled={disabled}
                onClick={this.handleResetErrorsClick}
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <Table
                tableHeader={modelHelper.buildTableRow([
                    modelHelper.buildTableCell(<Translate value="machineErrors.code" />),
                    modelHelper.buildTableCell(<Translate value="general.type" />),
                    modelHelper.buildTableCell(<Translate value="general.description" />),
                    modelHelper.buildTableCell(<Translate value="general.canister" />),
                    modelHelper.buildTableCell(<Translate value="machineErrors.channel" />)
                ])}
                tableRows={this.getTableRows()}
                tableColumns={[
                    modelHelper.buildTableColumn("col-2"),
                    modelHelper.buildTableColumn("col-2"),
                    modelHelper.buildTableColumn("col-4"),
                    modelHelper.buildTableColumn("col-2"),
                    modelHelper.buildTableColumn("col-2")
                ]}
            />
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getResetButton()}
                <CloseButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "flex-gap-10px"
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="machineErrors.machineErrors" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "50%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        machineErrors: store.rcc.machine.errors,
        isBusy: store.rcc.machine.isBusy,
        dialog: store.rcc.machine.dialog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseMachineErrorsModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MACHINE_ERRORS_MODAL));
        },
        dispatchResetErrors: () => {
            dispatch(rccActions.errorsResetMachine());
        }
    };
};

export default MachineErrorsModal = connect(mapStoreToProps, mapDispatchToProps)(MachineErrorsModal);
